




















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import PortalMenuSkeltonLoader from '@/components/atoms/skelton/PortalMenuSkeltonLoader.vue';
import PortalLinkEditDialog, {
  EditLinkBehavior,
  IEditItem,
} from '@/components/organisms/PortalLinkEditDialog.vue';
import PortalLinkMenusPanel from '@/components/organisms/PortalLinkMenusPanel.vue';
import { BusEvent, BusEventTargets } from '@/containers/globals/BusEvent';
import { linkUpdationModule } from '@/store/modules/LinkUpdationStore';
import {
  ID,
  LinkMenu,
  EditLinkMenuItem,
  EditActionEvent,
  EditActionBehavior,
  ChangeEvent,
  SaveEvent,
} from '@/types/type';

@Component({
  components: {
    PortalMenuSkeltonLoader,
    PortalLinkMenusPanel,
    PortalLinkEditDialog,
  },
})
export default class PortalLinkMenus extends Vue {
  @Prop()
  private loading!: boolean;

  @Prop()
  private menus!: LinkMenu[];

  @Prop()
  private canEditLink!: boolean;

  private editLinkAction() {
    linkUpdationModule.setUp(this.menus);
    BusEvent.$emit(BusEventTargets.FORM_DIALOG_LINK, true);
  }

  private get linkUpdationMenus(): LinkMenu[] {
    return linkUpdationModule.menuItems;
  }

  @Emit('change')
  private editAction(event: EditActionEvent): ChangeEvent {
    const behavior: EditActionBehavior = {
      edit: () => {},
      top: () => linkUpdationModule.top(event.index),
      up: () => linkUpdationModule.up(event.index),
      down: () => linkUpdationModule.down(event.index),
      bottom: () => linkUpdationModule.bottom(event.index),
      remove: () => linkUpdationModule.remove(event.index),
    };
    behavior[event.action]();
    return { change: true };
  }

  private saveItem(editItem: IEditItem): void {
    const behavior: EditLinkBehavior = {
      add: () => linkUpdationModule.add(editItem),
      edit: () => linkUpdationModule.update(editItem),
    };
    behavior[editItem.editType]();
  }

  @Emit('change-link-menus')
  private changeLinkMenus(event: LinkMenu[]): LinkMenu[] {
    this.saveCloseAction();
    return this.linkUpdationMenus;
  }

  @Emit('change')
  private saveCloseAction(e?: ChangeEvent): SaveEvent {
    if (e) {
      return e;
    }
    return { change: false };
  }
}
